


















import { Component, Mixins } from 'vue-property-decorator'
import { Getter, Action } from 'vuex-class'

// Helpers
import { Meta } from '@/helpers/decorators'

// Mixins
import Phone from '@/mixins/Phone'
import Errors from '@/mixins/Errors'

// Components
import Box from '@/components/common/Box.vue'
import DownloadAppPhoneInput from '@/components/fields/DownloadAppPhoneInput.vue'

@Component({
  components: { Box, DownloadAppPhoneInput }
})
export default class DownloadApp extends Mixins(Errors, Phone) {
  token: string = null
  plan: string = null

  @Action('resetState') resetState
  @Getter('token') storeToken

  @Meta
  metas() {
    return {
      title: this.$t('header.modal.download_title'),
      titleTemplate: `%s - ${process.env.VUE_APP_NAME}`
    }
  }

  mounted() {
    this.plan = this.$route.query.plan as string
    this.token = this.storeToken
    this.resetState()
  }

  submitTrial() {
    window.location.href = `${process.env.VUE_APP_TRIAL_URL}/#/login/${this.token}`
  }
}
